const WHATSAPP_PHONE = '573246353848';

const whatsappMessages = {
  EN: 'Hello, I hope you are well. I am interested in scheduling a consultation with Dr. Juan Salazar to discuss my questions and evaluate the best treatment options. Could you please share the next available appointments? Thank you.',
  ES: 'Hola, espero que se encuentre muy bien. Estoy interesado(a) en agendar una consulta con el Dr. Juan Salazar para resolver mis dudas y evaluar las mejores opciones de tratamiento. ¿Podrían por favor compartirme las próximas citas disponibles? Muchas gracias.',
  PT: 'Olá, espero que esteja bem. Tenho interesse em agendar uma consulta com o Dr. Juan Salazar para esclarecer minhas dúvidas e avaliar as melhores opções de tratamento. Poderiam, por favor, me informar os próximos horários disponíveis? Muito obrigado(a).',
};

export function getWhatsAppMessage(language) {
  return whatsappMessages[language] || whatsappMessages.EN;
}

export function getWhatsAppUrl(language) {
  const message = getWhatsAppMessage(language);
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
}

export { WHATSAPP_PHONE };
